import { Box, styled, Drawer, IconButton, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import Logo from "../../../assets/Images/wf-nav-logo.png";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const ImageBox = styled(Box)(({ theme }) => ({
  width: "130px",
  margin: "0 auto",
  textAlign: "center",
  paddingTop: "11px",
  cursor: "pointer",
}));
const DrawerHeadBox = ({ handleDrawerClose }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <>
      <DrawerHeader>
        <ImageBox onClick={() => navigate("/")}>
          <img src={Logo} alt="logoImage" style={{ width: "100%" }} />
        </ImageBox>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "rtl" ? (
            <ChevronRightIcon />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
      </DrawerHeader>
    </>
  );
};
export default DrawerHeadBox;
